module.exports = __webpack_public_path__ + "img/textuer.6b083779.svg";